module.exports = __webpack_public_path__ + "static/media/vypar.248704cb.webp";